export default __webpack_public_path__ + "static/media/sougatasir.e1252480.jpg";